(function () {
  function formatMoney(cents) {
    var euros = cents / 100;
    return '€' + euros.toLocaleString('nl-NL', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-count-target')) || 0;
    var isPlain = el.hasAttribute('data-count-plain');
    var duration = 1400;
    var start = null;

    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.round(target * eased);
      el.textContent = isPlain ? current : formatMoney(current);
      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        el.textContent = isPlain ? target : formatMoney(target);
      }
    }
    window.requestAnimationFrame(step);
  }

  function animateBar(el) {
    var target = parseFloat(el.getAttribute('data-bar-target')) || 0;
    requestAnimationFrame(function () {
      el.style.transition = 'width 1.2s ease';
      el.style.width = target + '%';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (window.__campaignCounterInit) return;
    window.__campaignCounterInit = true;

    var targets = document.querySelectorAll('[data-count-up], [data-bar-fill]');
    if (!targets.length) return;

    function runAnimation(el) {
      if (el.hasAttribute('data-count-up')) animateCount(el);
      if (el.hasAttribute('data-bar-fill')) animateBar(el);
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            runAnimation(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 });
      targets.forEach(function (el) { observer.observe(el); });
    } else {
      targets.forEach(runAnimation);
    }
  });
})();
